<div class="content">
    <div class="header">
        <ion-buttons>
            <ion-back-button defaultHref="" icon="close" text="" (click)="cancel()" class="red"></ion-back-button>
        </ion-buttons>
        <ion-buttons>
            <ion-back-button defaultHref="" icon="checkmark" text="" (click)="close()" class="green"></ion-back-button>
        </ion-buttons>
    </div>

    <div class="picker-container">
        <haleo-picker-column [col]="hours"
                             (onChange)="onChangeHour($event)"></haleo-picker-column>
        <ion-label>&#58;</ion-label>
        <haleo-picker-column [col]="minutes"
                             (onChange)="onChangeMinute($event)"></haleo-picker-column>
        <ion-label *ngIf="locale === 'en-ca'">&#58;</ion-label>
        <haleo-picker-column *ngIf="locale === 'en-ca'" [col]="amOrPm"
                             (onChange)="onChangeAmOrPm($event)"></haleo-picker-column>
    </div>
</div>

